<template>
  <v-container id="order-list" fluid tag="section">
    <base-material-card
      outlined
      icon="mdi-cash-multiple"
      class="overflow-visible order-list__wrapper"
    >
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Danh sách phiếu thu</div>
      </template>
      <!-- <v-btn
        class="mb-2 mr-0 ctv-create-btn"
        color="primary"
        v-if="checkAuthorization('order-ctv-create_read')"
        @click="ctvCreate()"
      >
        <span>Tạo mới</span>
        <v-icon style="margin-left: 10px; margin-right: -20px">mdi-plus</v-icon>
      </v-btn> -->
      <filer-form
        :filterForm="filterForm"
        @searchOrder="getOrderList"
      />
      <v-tabs
        @change="changeTab"
        v-model="tabIndex"
        color="primary"
        style="background-color: #ffffff; padding: 5px 0px 10px 5px"
      >
        <v-tab v-for="(tab, i) in tabs" :key="i">{{ tab }}</v-tab>
      </v-tabs>
      <!-- <v-divider class="ma-4 mb-2"  style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"/> -->
      <order-table :orders="orders" :currentPage="currentPage" typeTable="receipt" />
      <common-no-result v-if="!loading && orders.length === 0" />

      <!-- Paginate -->
      <div class="pb-0 d-flex justify-end px-3 mt-5">
        <div class="text-right mb-1 mt-2">
          {{ showContactsIndex() }}
          <v-btn
            small
            class="pagination-btn-left"
            @click="paginationChange('previous')"
            :disabled="currentPage == 1"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            small
            class="pagination-btn-right"
            @click="paginationChange('next')"
            :disabled="!paging.nextId"
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
        <!-- <div style="width: 35px">
          <v-text-field class="pt-0" v-model="pendingPage" min="1" step="1" type="number" @input="applyPendingPage()">
          </v-text-field>
        </div> -->
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import FilerForm from "./components/FilterFormReceipt";
import OrderTable from "./components/OrderTable";
import RepositoryFactory from "../../repositories/RepositoryFactory";
import TokenService from "../../helpers/token";
const OrderRepository = RepositoryFactory.get("order");

export default {
  components: {
    FilerForm,
    OrderTable,
  },
  data() {
    return {
      tabs: ["Tất cả", "Đã thành công", "Đang chờ", "Đã huỷ/thất bại"],
      tabIndex: 0,
      filterForm: {
        statusIds: [],
        receiptCode: null,
        orderCode: null,
        createdAt: [],
        createdBy: null,
        paymentType: null,
      },
      filterContactStatusList: [],
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      orders: [],
      loading: true,
      backward: false,
      paging: {},
      idPaging: null,
    };
  },
  async created() {
    this.appLoadingData(false);
    const dataUser = TokenService.getUser() || {};
    this.getOrderList();
  },
  methods: {
    ctvCreate() {
      this.$router.push("/orders/order-create");
    },
    changeTab() {
      if (this.tabIndex === 0) {
        this.filterForm.statusIds = [];
      } else if (this.tabIndex === 1) {
        this.filterForm.statusIds = ["final_success"];
      } else if (this.tabIndex === 2) {
        this.filterForm.statusIds = ["in_progress", "init"];
      } else if (this.tabIndex === 3) {
        this.filterForm.statusIds = [
          "final_cancel",
          "final_failed",
          "final_return",
        ];
      }
      this.currentPage = 1;
      this.getOrderList();
    },
    showContactsIndex() {
      if (this.orders.length > 0) {
        let maxIndex = parseInt(this.currentPage) * parseInt(this.limit);
        return maxIndex - parseInt(this.limit) + 1 + " - " + maxIndex;
      } else {
        return "0 - 0";
      }
    },
    async getOrderList() {
      const params = {
        limit: this.limit,
        page: this.currentPage,
        orderCode: this.filterForm.orderCode ? this.filterForm.orderCode.trim() : null,
        receiptCode: this.filterForm.receiptCode ? this.filterForm.receiptCode.trim() : null,
        userIds: this.filterForm.createdBy,
        paymentType: this.filterForm.paymentType,
        createdAt: this.filterForm.createdAt.filter(Boolean),
        statusIds: this.filterForm.statusIds.filter(Boolean),
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
        backward: this.backward,
        id: this.idPaging || "",
        isSumPrice: "",
      };

      if (!this.checkAuthorization("order_view_all")) {
        const dataUser = TokenService.getUser() || {};
        if (!params.userId && this.isStaff()) {
          params.userId = _.get(dataUser, "id", "");
        }
        // if (!params.departmentId && this.isLeader()) {
        //   params.departmentId = dataUser.departmentId;
        // }
      }

      if (this.tabIndex > 0 && params.statusIds.length == 0) {
        this.tabIndex = 0;
      }

      this.loading = true;
      // const loader = this.$loading.show();
      this.appLoadingData(true);
      const response = await OrderRepository.receiptList(params);
      // loader.hide();
      this.appLoadingData(false);
      this.loading = false;
      if (response.success) {
        this.orders = _.get(response, "data.data", []);
        this.paging = {
          nextId: _.get(response, "data.paging.nextId", null),
          previousId: _.get(response, "data.paging.previousId", null),
        };
        this.totalItem = _.get(response, "data.totalItem", 0);
      } else {
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: _.get(response, "message", ""),
        });
        this.orders = [];
        this.totalItem = 0;
      }
    },
    paginationChange(type) {
      if (type === "next") {
        this.currentPage++;
        this.idPaging = this.paging.nextId;
      } else {
        this.currentPage--;
        this.idPaging = this.paging.previousId;
      }
      this.getOrderList();
    },
  },
};
</script>
<style scoped>
#order-list {
  padding: 0px 15px;
}
.order-list__wrapper {
  padding-bottom: 0px !important;
  margin-bottom: 10px !important;
}
.ctv-create-btn {
  position: absolute;
  right: 22px;
  top: 10px;
}
</style>
